'use client';

import React, { useState, useEffect } from 'react';
import { getCdnUrl } from '@/utils/cdn';
import { motion, AnimatePresence } from 'framer-motion';

export const HeroParkEuropa: React.FC = () => {
    // Images from public/images/capa folder
    const images = [
        getCdnUrl("/images/park-europa/capa/capa-1.webp"),
        getCdnUrl("/images/park-europa/capa/capa-2.webp"),
        getCdnUrl("/images/park-europa/capa/capa-3.webp"),
        getCdnUrl("/images/park-europa/capa/capa-4.webp"),
        getCdnUrl("/images/park-europa/capa/capa-5.webp"),
        getCdnUrl("/images/park-europa/capa/capa-6.webp"),
        getCdnUrl("/images/park-europa/capa/capa-7.webp"),
        getCdnUrl("/images/park-europa/capa/capa-8.webp"),
        getCdnUrl("/images/park-europa/capa/capa-9.webp"),
        getCdnUrl("/images/park-europa/capa/capa-10.webp")
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <section className="relative w-full bg-white overflow-hidden">
            {/* The main content div with horizontal and bottom margins, touching top */}
            <div className=" mt-0 relative min-h-[600px] lg:min-h-[88dvh] bg-white overflow-hidden">
                
                {/* Background Carousel - Occupies the right part but with a fade */}
                <div className="absolute top-0 right-0 w-full lg:w-[65%] h-full z-0 overflow-hidden">
                    <AnimatePresence initial={false}>
                        <motion.div
                            key={currentIndex}
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 1.5, ease: "easeInOut" }}
                            className="absolute inset-0 w-full h-full"
                        >
                            <img 
                                src={images[currentIndex]} 
                                alt={`Park Europa Render ${currentIndex + 1}`} 
                                className="w-full h-full md:opacity-100 opacity-70 object-cover lg:object-right"
                                fetchPriority={currentIndex === 0 ? "high" : "auto"}
                            />
                        </motion.div>
                    </AnimatePresence>
                    {/* Fade overlay on the left side of the IMAGE area */}
                    <div className="absolute inset-y-0 left-0 w-full lg:w-1/2 bg-gradient-to-r from-white via-white/40 to-transparent z-10 pointer-events-none"></div>

                </div>

                {/* Content Layer */}
                <div className="relative z-20 h-full flex items-center min-h-[600px] ">
                    <div className="container mx-auto px-10 lg:px-32 py-16">
                        <div className="max-w-2xl space-y-6">
                            {/* Logo and Brand Name */}
                            <motion.div 
                                className="flex flex-col items-start"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 1.5, ease: "easeOut" }}
                            >
                                <img 
                                    src={getCdnUrl("/images/common/logo-park-europa.webp")} 
                                    alt="Park Europa Residencial" 
                                    className="h-[75px] lg:h-[105px] object-contain"
                                />
                            </motion.div>

                            {/* Main Title */}
                            <div className="space-y-4">
                                <h1 className="sr-only">
                                    Park Europa - Apartamentos de 2 Quartos em Barbacena - MG | Forbli Construtora
                                </h1>
                                <h2 className="text-forbli-dark font-black text-4xl lg:text-6xl leading-[1.05] tracking-tight">
                                    A casa é sua, <br/>
                                    <span className="text-forbli-dark">pode entrar!</span>
                                </h2>
                                <p className="md:text-gray-500 text-black text-base lg:text-lg font-light max-w-lg leading-relaxed">
                                    Realize o sonho da casa própria em <strong className="font-semibold text-gray-700">Barbacena - MG</strong> com a Forbli e o Minha Casa Minha Vida. Parcelas que cabem no seu bolso, condições facilitadas e tudo o que você precisa para viver com conforto, lazer e qualidade.
                                </p>
                            </div>

                            <div className="flex items-center gap-4 lg:gap-6 flex-wrap pt-6">
                                <img src={getCdnUrl("/images/common/logo-forbli.webp")} alt="Forbli" className="h-[24px] lg:h-[42px] object-contain" />
                                <img src={getCdnUrl("/images/common/logo-caixa.webp")} alt="Caixa" className="h-[18px] lg:h-[34px] object-contain" />
                                <img src={getCdnUrl("/images/common/logo-mcmv-alt.webp")} alt="Minha Casa Minha Vida" className="h-[24px] lg:h-[54px] object-contain" />
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </section>
    );
};
